import cc, { CurrencyCodeRecord } from "currency-codes";
import { useTranslation } from "react-i18next";
import styled from "styled-components/macro";
import { numberFormat } from "../../helpers/intl";
import { palette } from "../../styles/constants";
import { P } from "../Typography";
import View from "../View";

type MoneyProps = {
    amount: number | undefined;
    currency: string;
    boldCurrency?: boolean;
    hideCurrency?: boolean;
    doubleRow?: boolean;
    alignRight?: boolean;
};

const Money = ({
    currency,
    amount,
    boldCurrency,
    hideCurrency,
    doubleRow,
    alignRight,
}: MoneyProps) => {
    const { i18n } = useTranslation();
    const exponent =
        currency && cc.code(currency)
            ? (cc.code(currency) as CurrencyCodeRecord).digits
            : 2;
    const normalCurrencyAmount = (amount || 0) / Math.pow(10, exponent);
    const amountString =
        amount === undefined
            ? "?"
            : numberFormat(i18n.language, {
                  minimumFractionDigits: exponent,
              }).format(normalCurrencyAmount);

    if (doubleRow) {
        return (
            <View
                direction="column"
                wrap="nowrap"
                alignItems={alignRight ? "flex-end" : "flex-start"}
            >
                <P
                    lineHeight={20}
                    whiteSpace="nowrap"
                    fontFeatureSettings="tnum"
                >
                    {amountString}
                </P>
                <P lineHeight={20} color={palette.neutral[500]}>
                    {currency}
                </P>
            </View>
        );
    }

    if (hideCurrency) {
        return <Wrapper title={amountString}>{amountString}</Wrapper>;
    }
    if (boldCurrency) {
        return (
            <Wrapper title={`${amountString} ${currency}`}>
                {amountString} <Currency>{currency}</Currency>
            </Wrapper>
        );
    }
    return (
        <Wrapper title={`${amountString} ${currency}`}>
            {amountString} {currency}
        </Wrapper>
    );
};

const Wrapper = styled.span`
    white-space: nowrap;
    font-feature-settings: 'tnum';
    position: relative;
`;

const Currency = styled.span`
    font-size: 11px;
    font-weight: 700;
`;

export default Money;
